import { Link } from "react-router-dom";
import { ArrowUpRight, Navigation } from "lucide-react";
import { compactMoney, miles } from "@/lib/format";

/** Closest homes to the selected installation. Hover draws the distance line; click frames base + home together. */
export const NearbyHomes = ({ homes, activeKey, onHover, onPick, limit = 3 }) => {
  if (!homes.length) return <p className="text-[13px] text-neutral-500" data-testid="nearby-homes-empty">No homes inside this radius yet — try a wider ring.</p>;
  return (
    <ul className="space-y-1.5" data-testid="nearby-homes">
      {homes.slice(0, limit).map((h, i) => {
        const on = h.listing_key === activeKey;
        return (
          <li key={h.listing_key}
            className={`group items-center gap-3 rounded-md border p-1.5 pr-2 transition-colors ${i > 1 ? "hidden sm:flex" : "flex"} ${on ? "border-ink bg-ink text-white" : "border-neutral-200 hover:border-ink"}`}
            onMouseEnter={() => onHover(h.listing_key)} onMouseLeave={() => onHover(null)}>
            <button type="button" onClick={() => onPick(h)} data-testid={`nearby-home-${h.listing_key}`} className="flex min-w-0 flex-1 items-center gap-3 text-left">
              <img src={h.photos?.[0]} alt="" className="h-11 w-14 shrink-0 rounded object-cover" loading="lazy" />
              <span className="min-w-0 flex-1">
                <span className="block text-[14px] font-medium">{compactMoney(h.price)} · {h.beds} bd · {h.baths} ba</span>
                <span className={`block truncate text-[12px] ${on ? "text-white/70" : "text-neutral-500"}`}>{h.neighborhood}, {h.city}</span>
              </span>
              <span className={`flex shrink-0 items-center gap-1 font-mono text-[12px] ${on ? "text-brass" : "text-brass-deep"}`} data-testid={`nearby-home-miles-${h.listing_key}`}>
                <Navigation className="h-3 w-3" />{miles(h.base_miles)}
              </span>
            </button>
            <Link to={`/listing/${h.listing_key}`} aria-label="Open home" data-testid={`nearby-home-open-${h.listing_key}`}
              className={`grid h-7 w-7 shrink-0 place-items-center rounded-full ${on ? "bg-white text-ink" : "text-neutral-500 group-hover:text-ink"}`}>
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </li>
        );
      })}
    </ul>
  );
};
